export default __webpack_public_path__ + "static/media/Letter B.0d5473ee.mov";